import { FCP } from 'types';

interface Props extends FCP {
  fill?: string;
}

export const CaretDown = ({ fill = '#AAAAAA', className }: Props) => (
  <svg className={className} width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.87213 2.03214L8.61008 1.76827C8.52761 1.68586 8.41788 1.64046 8.30061 1.64046C8.18341 1.64046 8.07355 1.68586 7.99108 1.76827L5.00179 4.75769L2.00905 1.76495C1.92671 1.68254 1.81685 1.63721 1.69965 1.63721C1.58244 1.63721 1.47252 1.68254 1.39012 1.76495L1.128 2.02719C0.957333 2.19773 0.957333 2.47552 1.128 2.64606L4.69122 6.22209C4.77356 6.30443 4.88328 6.36245 5.00153 6.36245H5.00289C5.12016 6.36245 5.22989 6.30437 5.31223 6.22209L8.87213 2.65575C8.9546 2.57341 8.99987 2.46037 9 2.34316C9 2.22589 8.9546 2.11441 8.87213 2.03214Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.4"
    />
  </svg>
);
